// @ts-nocheck
/** @jsxImportSource @emotion/react */
import { css as emotionCss, SerializedStyles } from '@emotion/react';
import { Asterisk } from '@shared/react-ui-core';
import Imgix from 'react-imgix';
import { CheckboxIcon } from '../../Icons';
import { H2 } from '../../Typography';
import Divider from '../Divider';
import useStyle from './style';

const Showcase = ({
  image,
  title = 'You asked. We listened.',
  subtitle = 'As always, our security system provides effective and affordable protection against intruders, fires, indoor leaks, and more—now with these advanced features:',
  altItems,
  noTitle = false,
  wrapperCss,
  fontWeight = 300,
}: {
  image:
    | {
        id?: string;
        url: string;
        alt: string | null;
        title?: string | null;
      }
    | undefined;
  title?: string;
  subtitle?: string;
  altItems?: { text: string; imgURL?: string }[];
  noTitle?: boolean;
  fontWeight?: number;
  wrapperCss?: SerializedStyles | SerializedStyles[];
}) => {
  const {
    showcaseWrapper,
    showcaseContent,
    imageWrapper,
    showcaseText,
    checklistWrapper,
    checklistItem,
    dividerStyle,
  } = useStyle();

  const items = altItems || [
    {
      text: 'Up to 4 touchscreen alarm panels to place wherever is most convenient',
    },
    {
      text: 'Ethernet connection with cellular backup, so you’ll always stay connected',
    },
    {
      text: 'Brand new mobile app with enhanced capabilities',
    },
  ];

  return (
    <div
      css={emotionCss`
        ${showcaseWrapper};
        ${wrapperCss};
      `}
    >
      <div css={imageWrapper}>
        <Imgix
          src={image?.url || ''}
          htmlAttributes={{ alt: image?.alt || '', loading: 'lazy' }}
          width={720}
          height={530}
        />
      </div>
      <div css={showcaseContent}>
        {!noTitle && <H2>{title}</H2>}
        <p css={showcaseText}>{subtitle}</p>
        <div css={checklistWrapper}>
          {items.map((item, index) => (
            <div css={checklistItem} key={index}>
              {item.imgURL ? (
                <Imgix
                  src={item.imgURL}
                  htmlAttributes={{ alt: '' }}
                  width={17}
                  height={20}
                />
              ) : (
                <CheckboxIcon />
              )}
              <p
                dangerouslySetInnerHTML={{ __html: item.text }}
                style={{ fontWeight }}
              />
              {item?.text?.includes('Faster emergency dispatch') && (
                <Asterisk asteriskClassname="w-0 border-none bg-transparent">
                  *When compared to systems without RapidSOS integration and
                  text notifications as of Aug 2024
                </Asterisk>
              )}
            </div>
          ))}
        </div>
      </div>
      <Divider className='w-full' />
    </div>
  );
};

export default Showcase;
